import { Button, Stack, Typography } from "@mui/material";
import { FC } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import AnimateButton from "../../../components/@extended/AnimateButton";
import { IAuthState } from "../../../stateManagement/reducers/authReducer";
import {
  addItemToCart,
  decrementCartItemCount,
  ICartItem,
  ICartState,
} from "../../../stateManagement/reducers/cartReducer";
import { IRentalItem } from "../../../stateManagement/reducers/rentalItemsReducer";
import { IRootReducerT } from "../../../stateManagement/reduxStore";

interface IProps {
  openCartModal?: () => void;
  rentalItem: IRentalItem;
}

const SelectionButton: FC<IProps> = ({ rentalItem, openCartModal }) => {
  const navigate = useNavigate();
  const { authToken } = useSelector<IRootReducerT, IAuthState>(
    (state) => state.auth,
  );
  const { cart } = useSelector<IRootReducerT, ICartState>(
    (state) => state.cart,
  );
  const dispatch = useDispatch<any>();

  const cartItem: ICartItem | undefined = cart.items.find(
    (item) => item.rentalItem._id === rentalItem._id,
  );

  return (
    <>
      {!cartItem && (
        <AnimateButton>
          <Button
            variant="contained"
            size="large"
            color="info"
            sx={{
              color: "white !important",
              fontWeight: "700",
              // background: '#111',
              // background: 'linear-gradient(to bottom left, #111, #333, #111)'
              background: "linear-gradient(to top,#2b6e3f, #4caf50)",
              px: "1rem!important",
              py: ".5rem!important",
              mt: "2rem",
            }}
            onClick={() => {
              dispatch(addItemToCart({ rentalItem, count: 1 }));

              if (openCartModal) {
                setTimeout(() => {
                  openCartModal();
                }, 1000);
              }
            }}
          >
            Add to Cart
          </Button>
        </AnimateButton>
      )}
      {cartItem && (
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="center"
          sx={{ width: "fit-content", mt: "2rem", color: "#!important" }}
        >
          <AnimateButton>
            <Button
              variant="contained"
              size="large"
              color="info"
              sx={{
                color: "white !important",
                fontWeight: "700",
                // background: 'linear-gradient(to bottom left, #111, #333, #111)'
                background: "linear-gradient(to top, #8b0000, #ff5e57)",
                px: "1rem!important",
                py: ".5rem!important",
              }}
              onClick={() => {
                dispatch(
                  decrementCartItemCount({
                    rentalItemId: cartItem.rentalItem._id,
                    count: 1,
                  }),
                );
              }}
            >
              -
            </Button>
          </AnimateButton>
          <Typography sx={{ pl: ".5rem", color: "background.default" }}>
            <b>{cartItem.count}</b>
          </Typography>
          <Typography
            sx={{ pl: ".25rem", pr: ".5rem", color: "background.default" }}
          >
            in your cart
          </Typography>
          <AnimateButton>
            <Button
              variant="contained"
              size="large"
              color="info"
              sx={{
                color: "white !important",
                fontWeight: "700",
                // background: '#111',
                // background: 'linear-gradient(to bottom left, #111, #333, #111)'
                background: "linear-gradient(to top,#2b6e3f, #4caf50)",
                px: "1rem!important",
                py: ".5rem!important",
              }}
              onClick={() => {
                dispatch(addItemToCart({ rentalItem, count: 1 }));
              }}
            >
              +
            </Button>
          </AnimateButton>
        </Stack>
      )}
    </>
  );
};

export default SelectionButton;
